const root = {
  accessDenied: 'Accès refusé',
  wrongPermissionsDesc:
    "Oups! Vous n'êtes pas autorisé à accéder à la page demandée. Si vous pensez que vous devriez avoir accès, veuillez contacter votre administrateur.",
};
export default root;
